import React from 'react';

const Skeleton = ({ width = '100%', height = '20px', className = '', variant = 'rectangular' }) => {
  const baseClasses = 'animate-pulse bg-gray-200 dark:bg-gray-700';
  
  const variantClasses = {
    rectangular: 'rounded',
    circular: 'rounded-full',
    text: 'rounded',
  };

  const style = {
    width,
    height,
  };

  return (
    <div
      className={`${baseClasses} ${variantClasses[variant]} ${className}`}
      style={style}
      aria-label="Loading..."
    />
  );
};

export const ProductCardSkeleton = () => (
  <div className="card transform transition-transform duration-300 animate-pulse">
    <div className="relative w-full h-48 sm:h-56 bg-gray-200 dark:bg-gray-700 rounded-t-lg">
      {/* Image placeholder */}
      <div className="w-full h-full bg-gray-300 dark:bg-gray-600 rounded-t-lg"></div>
      
      {/* Badge placeholders */}
      <div className="absolute top-3 left-3 space-y-2">
        <Skeleton width="60px" height="24px" className="rounded-full" />
      </div>
    </div>

    <div className="p-4 flex flex-col flex-grow">
      {/* Title */}
      <Skeleton width="80%" height="24px" className="mb-2" />
      
      {/* Price */}
      <div className="flex items-baseline space-x-2 mb-3">
        <Skeleton width="60px" height="20px" />
        <Skeleton width="40px" height="16px" />
      </div>
      
      {/* Stars */}
      <div className="flex items-center mb-4">
        <div className="flex space-x-1">
          {[...Array(5)].map((_, i) => (
            <Skeleton key={i} width="20px" height="20px" variant="circular" />
          ))}
        </div>
        <Skeleton width="60px" height="16px" className="ml-2" />
      </div>
      
      {/* Button */}
      <Skeleton width="100%" height="44px" className="mt-auto rounded-lg" />
    </div>
  </div>
);

export const CategoryCardSkeleton = () => (
  <div className="card flex flex-col items-center justify-center p-6 rounded-lg shadow-md animate-pulse">
    {/* Icon */}
    <Skeleton width="80px" height="80px" variant="circular" className="mb-4" />
    
    {/* Title */}
    <Skeleton width="120px" height="20px" className="mb-2" />
    
    {/* Product count */}
    <Skeleton width="80px" height="16px" />
  </div>
);

export const FeatureCardSkeleton = () => (
  <div className="card p-8 text-center animate-pulse">
    {/* Icon */}
    <Skeleton width="32px" height="32px" variant="circular" className="mx-auto mb-4" />
    
    {/* Title */}
    <Skeleton width="60%" height="24px" className="mx-auto mb-2" />
    
    {/* Description */}
    <div className="space-y-2">
      <Skeleton width="100%" height="16px" />
      <Skeleton width="80%" height="16px" className="mx-auto" />
    </div>
  </div>
);

export const HeroSkeleton = () => (
  <section className="relative w-full h-[500px] bg-gray-200 dark:bg-gray-700 flex items-center justify-center overflow-hidden mb-12 animate-pulse">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
      {/* Title */}
      <Skeleton width="60%" height="48px" className="mx-auto mb-6" />
      
      {/* Description */}
      <div className="space-y-3 mb-10">
        <Skeleton width="80%" height="20px" className="mx-auto" />
        <Skeleton width="60%" height="20px" className="mx-auto" />
      </div>
      
      {/* Buttons */}
      <div className="flex flex-col sm:flex-row gap-4 justify-center">
        <Skeleton width="200px" height="56px" className="rounded-lg" />
        <Skeleton width="150px" height="56px" className="rounded-lg" />
      </div>
    </div>
  </section>
);

export default Skeleton;